vDepthLastEvent = instanceLastEvent;
vDepthDissolveValue = instanceDissolveValue;
vUv = uv;
